
import { useState } from 'react';
import TopNavigation from '../../components/feature/TopNavigation';
import BottomNavigation from '../../components/feature/BottomNavigation';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';

export default function Profile() {
  const [user] = useState({
    name: 'أحمد محمد العلي',
    email: 'ahmed.ali@email.com',
    phone: '+966 50 123 4567',
    location: 'الرياض، السعودية',
    joinDate: '2023-06-15',
    rating: 4.8,
    completedJobs: 24,
    totalEarnings: '12,500',
    avatar: 'https://public.readdy.ai/ai/img_res/a24f3302e28e3878265be4330b7e0c50.jpg'
  });

  const stats = [
    {
      icon: 'ri-star-fill',
      label: 'التقييم',
      value: user.rating.toString(),
      color: 'text-[#FBC02D]'
    },
    {
      icon: 'ri-briefcase-fill',
      label: 'الوظائف المكتملة',
      value: user.completedJobs.toString(),
      color: 'text-[#4CAF50]'
    },
    {
      icon: 'ri-money-dollar-circle-fill',
      label: 'إجمالي الأرباح',
      value: `${user.totalEarnings} ريال`,
      color: 'text-[#1565C0]'
    }
  ];

  const menuItems = [
    {
      icon: 'ri-user-line',
      title: 'تعديل الملف الشخصي',
      subtitle: 'تحديث معلوماتك الشخصية',
      action: () => {}
    },
    {
      icon: 'ri-file-text-line',
      title: 'السيرة الذاتية',
      subtitle: 'إدارة مهاراتك وخبراتك',
      action: () => {}
    },
    {
      icon: 'ri-shield-check-line',
      title: 'التحقق من الهوية',
      subtitle: 'تأكيد هويتك لمزيد من الثقة',
      badge: 'مكتمل',
      badgeColor: 'bg-[#4CAF50] text-white'
    },
    {
      icon: 'ri-bank-card-line',
      title: 'طرق الدفع',
      subtitle: 'إدارة حساباتك البنكية',
      action: () => {}
    },
    {
      icon: 'ri-notification-line',
      title: 'الإشعارات',
      subtitle: 'تخصيص تفضيلات الإشعارات',
      action: () => {}
    },
    {
      icon: 'ri-lock-line',
      title: 'الخصوصية والأمان',
      subtitle: 'إعدادات الحماية والخصوصية',
      action: () => {}
    },
    {
      icon: 'ri-question-line',
      title: 'المساعدة والدعم',
      subtitle: 'الحصول على المساعدة',
      action: () => {}
    },
    {
      icon: 'ri-settings-line',
      title: 'الإعدادات',
      subtitle: 'تخصيص تجربة التطبيق',
      action: () => {}
    }
  ];

  const achievements = [
    {
      icon: 'ri-trophy-line',
      title: 'أفضل مضيف',
      description: 'حصلت على أعلى تقييم في فئة الضيافة',
      date: '2024-01-10',
      color: 'bg-[#FBC02D]'
    },
    {
      icon: 'ri-time-line',
      title: 'الالتزام بالمواعيد',
      description: 'لم تتأخر عن أي موعد عمل',
      date: '2024-01-05',
      color: 'bg-[#4CAF50]'
    },
    {
      icon: 'ri-team-line',
      title: 'روح الفريق',
      description: 'تقييم ممتاز في العمل الجماعي',
      date: '2023-12-20',
      color: 'bg-[#1565C0]'
    }
  ];

  return (
    <div className="min-h-screen bg-[#FDFDFD]">
      <TopNavigation 
        title="الملف الشخصي"
        rightAction={
          <button className="w-8 h-8 flex items-center justify-center">
            <i className="ri-edit-line text-lg"></i>
          </button>
        }
      />

      <div className="pt-14 pb-20 px-4">
        {/* Profile Header */}
        <Card className="mb-6 mt-4">
          <div className="text-center">
            <div className="relative inline-block mb-4">
              <img 
                src={user.avatar} 
                alt={user.name}
                className="w-20 h-20 rounded-full object-cover mx-auto"
              />
              <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-[#4CAF50] rounded-full border-2 border-white flex items-center justify-center">
                <i className="ri-check-line text-white text-xs"></i>
              </div>
            </div>
            <h2 className="text-xl font-bold text-[#333333] mb-1">{user.name}</h2>
            <p className="text-[#607D8B] text-sm mb-2">{user.email}</p>
            <p className="text-[#757575] text-sm mb-4">
              <i className="ri-map-pin-line ml-1"></i>
              {user.location}
            </p>
            <div className="flex items-center justify-center text-[#757575] text-sm">
              <i className="ri-calendar-line ml-1"></i>
              عضو منذ {new Date(user.joinDate).toLocaleDateString('ar-SA', { year: 'numeric', month: 'long' })}
            </div>
          </div>
        </Card>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-3 mb-6">
          {stats.map((stat, index) => (
            <Card key={index} className="text-center">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-2 ${stat.color.replace('text-', 'bg-')}/10`}>
                <i className={`${stat.icon} ${stat.color}`}></i>
              </div>
              <p className="text-lg font-bold text-[#333333]">{stat.value}</p>
              <p className="text-[#757575] text-xs">{stat.label}</p>
            </Card>
          ))}
        </div>

        {/* Achievements */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-[#333333] mb-4">الإنجازات</h3>
          <Card>
            <div className="space-y-4">
              {achievements.map((achievement, index) => (
                <div key={index} className="flex items-start">
                  <div className={`w-10 h-10 ${achievement.color} rounded-full flex items-center justify-center ml-3 flex-shrink-0`}>
                    <i className={`${achievement.icon} text-white`}></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="font-semibold text-[#333333] text-sm">{achievement.title}</h4>
                    <p className="text-[#757575] text-xs mb-1">{achievement.description}</p>
                    <p className="text-[#607D8B] text-xs">
                      {new Date(achievement.date).toLocaleDateString('ar-SA')}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>

        {/* Menu Items */}
        <div className="space-y-3">
          {menuItems.map((item, index) => (
            <Card key={index} className="hover:shadow-md transition-shadow cursor-pointer">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-[#F5F5F5] rounded-full flex items-center justify-center ml-3">
                    <i className={`${item.icon} text-[#607D8B]`}></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#333333] text-sm">{item.title}</h4>
                    <p className="text-[#757575] text-xs">{item.subtitle}</p>
                  </div>
                </div>
                <div className="flex items-center">
                  {item.badge && (
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ml-2 ${item.badgeColor}`}>
                      {item.badge}
                    </span>
                  )}
                  <i className="ri-arrow-left-s-line text-[#607D8B]"></i>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Logout Button */}
        <div className="mt-8">
          <Button variant="outline" className="w-full text-red-500 border-red-500 hover:bg-red-500 hover:text-white">
            <i className="ri-logout-box-line ml-2"></i>
            تسجيل الخروج
          </Button>
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
}
